import React from 'react';
import { ChakraV3 } from '..';

interface Props {
  isOpen: boolean;
  w: string;
}

export const MotionSlideOut = (props: React.PropsWithChildren<Props>) => {
  const { isOpen, w } = props;

  return (
    <ChakraV3.Box
      flexShrink={0}
      h='full'
      overflow='hidden'
      w={isOpen ? w : 0}
      opacity={isOpen ? 1 : 0}
      transition='width 300ms ease-in-out, opacity 300ms ease-in-out'
    >
      <ChakraV3.Box w={w} h='full'>
        {props.children}
      </ChakraV3.Box>
    </ChakraV3.Box>
  );
};
